import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MojoPrivilegesService } from 'mojo-privileges';

import { DangerAlert } from '@shared/alert';

@Injectable({
  providedIn: 'root',
})
export class PrivilegesAdapter {
  constructor(
    private mojoPrivilegesService: MojoPrivilegesService,
    private store: Store<{}>,
  ) {}

  initializeErrorHandling() {
    this.mojoPrivilegesService.errors$.subscribe((requiredPrivileges) => {
      this.store.dispatch(new DangerAlert(`Access denied`));
    });
  }
}
